import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getDashboardData = createAsyncThunk(
    "dashboard/list",
    async ({ pageCount, limit, search }) => {
        console.log(pageCount, "PAGE");
        console.log(limit, "PAGE");
        console.log(search, "PAGE");

        const response = await Client(
            API_METHOD.GET,
            url.dashboard +
            `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${!search ? "" : search
            }`
        );
        return response.data;
    }
);

